export default __webpack_public_path__ + "static/media/mps-2025-class-12-science-result.0895c42f.jpg";